export function determineCredentialsMode() {
  const isCredentialsSupported = "credentials" in Request.prototype;
  if (!isCredentialsSupported) {
    return void 0;
  }
  return "include";
}
